import * as React from 'react';

const SCRIPT_ID = 'pinterest-embed-script';
export const usePinterest = (pinId: string) => {
  React.useEffect(() => {
    const win: any = window;
    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.type = 'text/javascript';
      script.dataset.pinBuild = 'doBuild';
      script.src = '//assets.pinterest.com/js/pinit.js';
      script.id = SCRIPT_ID;
      document.body.appendChild(script);
    }

    if (win.doBuild) {
      win.doBuild();
    }
  }, [pinId]);
};
